















































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetCenter } from "@/request/zhuanbingshujuku";
@Component({})
export default class MainHeaderView extends Vue {
  private window: any = window;
  @Prop()
  private cState: any;
  private tempC: any = {};
  private centers: any[] = [];
  private get center() {
    const localCenter = localStorage.getItem("center");
    if (!localCenter) {
      return {};
    } else {
      return JSON.parse(localCenter);
    }
  }
  private set center(val) {
    localStorage.setItem("center", JSON.stringify(val));
    this.$router.push("/main/zbsjk/zbsjk-list");
    // this.$router.go(0);
  }
  private get user() {
    return this.$store.state.user;
  }
  private get ifLowHeight() {
    if (window.innerHeight <= 670) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * @description 获得专病数据库列表
   */
  private getCenterList() {
    GetCenter(this).then((data: any) => {
      this.centers = data;
    });
  }
  /**
   * @description 跳转
   */
  private jump(url) {
    this.$router.push(url);
  }
  /**
   * @description 跳转智能看舌
   */
  private jumpTongueList() {
    localStorage.setItem(
      "tongueListFilters",
      JSON.stringify({
        hospital_ids: [],
        范围: [],
        search: "",
        性别: "",
        开始时间: "",
        结束时间: "",
        年龄段: [],
        timeWay: "",
        time: [],
        条件: "",
        研究指标: [],
        自定义年龄: [false],
        时间段: "",
        自定义时间段: [false, []],
        currentPage: 1,
        orderField: "创建时间",
        orderValue: 0,
        pageCount: 12,
        primaryFilters: {},
        totalCount: 0,
        ifPrimarySearched: false,
      })
    );
    this.$router.push("/main/tongue/tongue-list");
  }
  /**
   * @description 跳转账户管理
   */
  private jumpZhgl() {
    localStorage.setItem(
      "zhglFilter",
      JSON.stringify({
        search: "",
        institution_id: "",
        current_page: 1,
        page_count: 10,
        sort_value: "0",
      })
    );
    this.$router.push("/main/yhqx/zhgl-list");
  }
  /**
   * @description 跳转个人中心
   */
  private goAccountManage() {
    localStorage.setItem(
      "beforeAccountSource",
      JSON.stringify({
        path: this.$route.path,
        query: this.$route.query,
      })
    );
    this.$router.push({
      path: "/main/account/account-setting",
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.getCenterList();
  }
}
